export const LOGIN_PAGE_URL = "/login";

export const APP_TRANSPARENT_URL = "/_app";

// biome-ignore lint/suspicious/noExplicitAny: needed
export const getAppWrappedPageUrl = (pageUrl: string): any => {
	return `${APP_TRANSPARENT_URL}${pageUrl}`;
};

export const STATUS_PAGE_URL = "/status";
export const MILLING_JOBS_PAGE_URL = "/milling-jobs";
export const TOOLS_PAGE_URL = "/tools";
export const BLANKS_PAGE_URL = "/blanks";
export const ACTIVE_JOB_DETAILS_PAGE_URL = "/active-job-details";
export const QUEUED_JOB_DETAILS_PAGE_URL = "/queued-job-details";
export const EXECUTED_JOB_DETAILS_PAGE_URL = "/executed-job-details";
export const LIBRARY_TOOL_DETAILS_PAGE_URL = "/library-tool-details";
export const RACK_TOOL_DETAILS_PAGE_URL = "/rack-tool-details";
export const USED_TOOL_DETAILS_PAGE_URL = "/used-tool-details";
export const LIBRARY_BLANK_DETAILS_PAGE_URL = "/library-blank-details";
export const MAGAZINE_SLOT_DETAILS_PAGE_URL = "/magazine-slot-details";
